import { formatDetailDate } from '../../../../helpers/date';
import { FundLipperRatingData } from '../../../../types/fundsummary.type';
import './LipperRating.css';

export interface LipperRatingProps {
  updateDate: string;
  lipperRating?: FundLipperRatingData;
  filledThreshold?: number;
}

const LipperRating = ({
  updateDate,
  lipperRating,
  filledThreshold = 4,
}: LipperRatingProps): JSX.Element => {
  const lipperScores = [
    {
      label: 'Total Return',
      value: lipperRating?.totalReturn.scoreOverallValue ?? 'NA',
    },
    {
      label: 'Consistent Return',
      value: lipperRating?.consistentReturn.scoreOverallValue ?? 'NA',
    },
    {
      label: 'Preservation',
      value: lipperRating?.preservation.scoreOverallValue ?? 'NA',
    },
    {
      label: 'Expense',
      value: lipperRating?.expense.scoreOverallValue ?? 'NA',
    },
  ];

  return (
    <section className="lipper-rating">
      <div className="lipper-rating__subheader">
        <span className="lipper-rating__subheader-title">
          Lipper rating (Overall)
        </span>
        <span className="lipper-rating__subheader-meta">
          {formatDetailDate(updateDate, false, 'DMY')}
        </span>
      </div>

      <div className="lipper-rating__scores">
        {lipperScores.map((score) => (
          <div className="lipper-rating__score" key={score.label}>
            <span className="lipper-rating__score-label">{score.label}</span>
            <span
              className={`lipper-rating__score-badge${
                Number(score.value) >= filledThreshold
                  ? ' lipper-rating__score-badge--filled'
                  : ''
              }`}
            >
              {score.value}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LipperRating;
